import { Modal } from 'antd';
import { globalStore, load, mock } from '@/common'
import { registerMocks } from './mock';
import { Demand, DemandAddEditParam, demandPageModel } from './model';  
import { demandApi } from './DemandApi';
const initialize = async () => {
    if(mock){
        registerMocks();
    }
    if(!globalStore.currentUser){
        load();
    } 
    await demandPageModel.initialize();
}   
const handleQueryOperationListById = async (id: number) => {
    // store.currOperationInfos = []
    // const res: any = await recordReq.run({
    //   bugId: id
    // })
    // if (res.success) {
    //   store.currOperationInfos = [...(res.result || [])]
    // }
}

const addDemand = async (demand: DemandAddEditParam) : Promise<number> => {
    return  await demandApi.addOrEditDemand(demand);
};

const updateDemand =  async (demand: DemandAddEditParam) : Promise<void>=> {
    await demandApi.addOrEditDemand(demand);
    return;
};

const deleteDemand =  (id:string | number) => {

    Modal.confirm({
        title: '操作确认',
        content: '是否确认删除该需求',
        onOk: async () => {
            const result =  await demandApi.deleteDemand(id);
            if(result){
               demandPageModel.demandList = demandPageModel.demandList.filter((demand:Demand)=>{
                return demand.id != id;
               })
            }
        }
      }) 
 }

 const changeStatus = async (id:string | number, status:number)=>{
     const param : DemandAddEditParam = new DemandAddEditParam();
     param.id = id;
     param.status = status;
     demandApi.addOrEditDemand(param);
 }



export const ctrl = {
    initialize,
    addDemand,
    updateDemand,
    deleteDemand,
    changeStatus
}